import React from 'react'
import { number, bool } from 'prop-types'
import { TagIcon, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'

function SummaryLabel({ numberOfTags = 0, hasAnyTagsWithPenalty, limitTagCampaignsAndCostInflation = false }) {
  if (numberOfTags === 0) {
    if (limitTagCampaignsAndCostInflation && hasAnyTagsWithPenalty) {
      return null
    }

    return (
      <span className="promote-modal__summary-label">
        No tags selected
      </span>
    )
  }

  if (limitTagCampaignsAndCostInflation && hasAnyTagsWithPenalty) {
    return (
      <div className="promote-modal__summary-label--with-trending-tags">
        <Icon
          color="dark"
          svgComponent={TagIcon}
        />
        <span className="promote-modal__summary-label-text">REGULAR TAGS</span>
        <div className="promote-modal__summary-label-divider" />
      </div>
    )
  }

  return (
    <span className="promote-modal__summary-label">
      {numberOfTags} {numberOfTags === 1 ? 'tag' : 'tags'} selected
    </span>
  )
}

SummaryLabel.propTypes = {
  numberOfTags: number,
  hasAnyTagsWithPenalty: bool.isRequired,
  limitTagCampaignsAndCostInflation: bool,
}

export default SummaryLabel
